import { ReactNode } from 'react';
import { BordOneToneIcon } from 'components/NudosComponents';
import { bannerVariant } from 'types/quoteDetails.types';
import { TbordOneToneIconVariant } from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';

import './QuoteDetailBanner.scss';

interface IQuoteDetailBanner {
  variant: bannerVariant;
  content: ReactNode;
}

/**
 * Banner informativo del detalle de cotización. Soporta variantes: information, warning y danger.
 */
const QuoteDetailBanner = ({ variant, content }: IQuoteDetailBanner) => {
  const variantConfig = {
    [bannerVariant.information]: { icon: 'info' as const, stroke: '#4096F0' },
    [bannerVariant.warning]: { icon: 'alertTriangleWarning' as const, stroke: '#FFBB00' },
    [bannerVariant.danger]: { icon: 'xCircle' as const, stroke: '#EA3323' }
  };
  const config = variantConfig[variant];

  return (
    <div className={`quoteDetailBanner ${variant}`}>
      <BordOneToneIcon variant={config.icon as TbordOneToneIconVariant} standardSize={16} stroke={config.stroke} />
      <div className="bannerContent">{content}</div>
    </div>
  );
};

export default QuoteDetailBanner;
